interface BrandLogoProps {
  compact?: boolean;
  className?: string;
}

export function BrandLogo({ compact = false, className = "" }: BrandLogoProps) {
  return (
    <div className={`brand-logo ${compact ? "brand-logo--compact" : ""} ${className}`.trim()}>
      <img src="/ubisafe-logo-white.webp" alt="UbiSafe" />
      {!compact && <span>Gestão de Tenants</span>}
    </div>
  );
}
